"use strict";

exports.__esModule = true;
exports.MeasureTimelineSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Fields = require("../../AdvancedDataTable/Fields");
var _AdvancedDataSources = require("../../AdvancedDataTable/AdvancedDataSources");
var _Spinner = require("../../../Core/Spinner");
var _Selector = require("../../../Core/Selector");
var _core = require("@blueprintjs/core");
var _Translator = require("../../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MeasureTimelineSelector = exports.MeasureTimelineSelector = function MeasureTimelineSelector(_ref) {
  var selectedMeasure = _ref.selectedMeasure,
    handleMeasureSelect = _ref.handleMeasureSelect;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var selectedDataSource = selectedMeasure && selectedMeasure.length > 0 ? selectedMeasure[0].dataSourceType : "";
  var _useState = (0, _react.useState)(selectedDataSource),
    dataSource = _useState[0],
    setDataSource = _useState[1];
  return /*#__PURE__*/_react["default"].createElement(_AdvancedDataSources.AdvancedDataSourceContext.Consumer, null, function (_ref2) {
    var loaded = _ref2.loaded,
      fetching = _ref2.fetching,
      error = _ref2.error,
      data = _ref2.data;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "MeasureTimelineSelector"
    }, fetching && !data ? /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null) : null, !error && loaded && data ? /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "MeasureTimelineSelectorFields"
    }, /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataSourceField, {
      helperText: translate("MeasureTimelineSelector.timelineDataSource.helperText", "Select the Timeline to display in the widget"),
      key: "MeasureTimelineSelector.AdvancedDataSourceField",
      sources: data.timelineIdentifiers || [],
      value: dataSource,
      setProp: function setProp(val) {
        if (val !== selectedMeasure) {
          setDataSource(val);
          handleMeasureSelect([]);
        }
      }
    }), /*#__PURE__*/_react["default"].createElement(MeasureSelector, {
      dataSource: dataSource,
      timelineDefinitions: data.timelineDefinitions,
      selectedMeasure: selectedMeasure,
      handleMeasureSelect: handleMeasureSelect
    })) : null);
  });
};
function getKey(input) {
  return input.id;
}
function itemPredicate(query, input) {
  var q = query.toLowerCase();
  return input.name.toLowerCase().indexOf(q) !== -1;
}
function renderItemText(input) {
  return input.name;
}
var MeasureSelector = function MeasureSelector(_ref3) {
  var dataSource = _ref3.dataSource,
    timelineDefinitions = _ref3.timelineDefinitions,
    selectedMeasure = _ref3.selectedMeasure,
    handleMeasureSelect = _ref3.handleMeasureSelect;
  var _React$useContext2 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext2.translate;
  var definitions = dataSource && timelineDefinitions[dataSource] ? timelineDefinitions[dataSource] : null;
  var measures = definitions && definitions.columns ? definitions.columns : [];
  measures = measures.reduce(function (t, _ref4) {
    var id = _ref4.id,
      name = _ref4.name,
      sanitizedFieldName = _ref4.sanitizedFieldName;
    if (id.split(".")[0] === "measures") {
      return t.concat({
        id: id,
        name: name,
        sanitizedFieldName: sanitizedFieldName,
        color: "",
        dataSourceType: dataSource
      });
    }
    return t;
  }, []);
  if (measures.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: "15px",
        fontWeight: 600
      }
    }, "No Measure");
  }
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    helperText: translate("MeasureSelector.HelperText", "Select a Measure")
  }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    filterable: false,
    onSelect: handleMeasureSelect,
    selected: selectedMeasure,
    items: measures,
    getKey: getKey,
    renderItemText: renderItemText,
    multiple: false,
    itemPredicate: itemPredicate,
    placeholder: "Select a Measure"
  }));
};